module.exports = __webpack_public_path__ + "img/sixpackcarrier48.92c6cac9.jpg";